import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useHabilidadesFilters
 */

type State = {
  tipoPesquisa: number;
  valueField: string;
  status: number;
};

type Action = {
  setTipoPesquisa: (tipoPesquisa: number) => void,
  setValueField: (valueField: string) => void,
  setStatus: (status: number) => void,
};

export const useHabilidadesFilters = create<State & Action>((set) => ({
  tipoPesquisa: 1,
  valueField: "",
  status: 2,
  setTipoPesquisa: (tipoPesquisa) => set({ tipoPesquisa }),
  setValueField: (valueField) => set({ valueField }),
  setStatus: (status) => set({ status }),
}));